import * as React from 'react';

import { readTablePreferences, saveTablePreferences } from '@app/utils/tablePreferences';

/**
 * Page size for a page's table, remembered per page in a cookie.
 *
 * Per page rather than global, unlike the condensed/normal density in
 * densityPreference: how many rows are useful depends on the table, while how
 * tightly to draw them depends on the user's screen.
 *
 * @param pageKey Names this table in the cookie. Must be unique across the app
 *                and stable across releases - changing it silently resets the
 *                choice the user made.
 * @param defaultPerPage Page size before the user picks one.
 */
export const useTablePreferences = (pageKey: string, defaultPerPage = 10) => {
  const [perPage, setPerPageState] = React.useState<number>(
    () => readTablePreferences(pageKey).perPage ?? defaultPerPage
  );

  const setPerPage = React.useCallback((rows: number) => {
    setPerPageState(rows);
    saveTablePreferences(pageKey, { perPage: rows });
  }, [pageKey]);

  return { perPage, setPerPage };
};
